import { FetchIsRestrictedImpersonateeActionTypes } from '../actions/IsRestrictedImpersonateeActions';
import { handleActions } from 'flux-actions';
const initialState = {};
export default handleActions({
  [FetchIsRestrictedImpersonateeActionTypes.SUCCESS](state, action) {
    return action.payload.data;
  }
}, initialState);